export enum JobService {
  ANP_CUSTOMER_JOB = "anp",
}

export interface ICallJobsService {
  execute(data: JobService): Promise<void>;
}
